import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'unitTranslate',
  standalone: true,
  pure: false
})
export class UnitTranslatePipe implements PipeTransform {
  private langChangeSub?: Subscription;
  private lastValue: string = '';
  private lastLang: string = '';

  constructor(private translate: TranslateService, private cdr: ChangeDetectorRef) {
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  transform(value: string): string {
    if (!value) return value;

    const lang = this.translate.currentLang;
    if (value === this.lastValue && lang === this.lastLang) return this.lastValue;

    let result = value;

    switch (lang) {
      case 'en-US':
        result = result
          .replace(/Га/g, 'ha')
          .replace(/км²/g, 'km²')
          .replace(/км2/g, 'km²');
        break;

      case 'uz-Latn-UZ':
        result = result
          .replace(/Га/g, 'ga')
          .replace(/км²/g, 'km²')
          .replace(/км2/g, 'km²');
        break;

      case 'ru-RU':
      default:
        break;
    }

    this.lastValue = result;
    this.lastLang = lang;

    return result;
  }

  ngOnDestroy() {
    this.langChangeSub?.unsubscribe();
  }
}
